import React from 'react';
import { Button } from '@material-ui/core';
import translate from '../../../../../i18n/translate';
import { CloseIcon } from '../../../../common/icon';
import { vocabularyDeleteWord } from '../../../../../redux/actions/vocabularyCenterAction';

interface DeleteWarningProps {
  setIsDeleteClicked: (value: boolean) => void;
  dispatch: (action: any)=> void; // Adjust the type as necessary
  token: string; // Assuming token is directly passed as a prop for simplicity
  listId: string;
  wordId: string;
  USER: string; // Adjust the type as necessary
}

const DeleteWarning: React.FC<DeleteWarningProps> = ({
  setIsDeleteClicked,
  dispatch,
  token,
  listId,
  wordId,
  USER,
}) => {
  return (
    <div className="delete-warning-container">
      <div className="title-container">
        <p className="new-word-label">{translate("vocab_center_delete_word_text")}</p>
        <CloseIcon
          data-testid="close-icon"
          className="close-icon"
          onClick={() => {
            setIsDeleteClicked(false);
          }}
        />
      </div>
      <p className="delete-warning-message">{translate("vocab_center_delete_word_warning_message")}</p>
      <div className="delete-warning-actions">
        <Button
          variant="contained"
          className="delete-button"
          onClick={() => {
            dispatch(
              vocabularyDeleteWord(
                token,
                listId,
                wordId,
                USER,
              ),
            );
            setIsDeleteClicked(false);
          }}
        >
          {translate("vocab_center_yes_text")}
        </Button>
        <Button
          variant="contained"
          className="delete-button"
          onClick={() => {
            setIsDeleteClicked(false);
          }}
        >
          {translate("vocab_center_close_text")}
        </Button>
      </div>
    </div>
  );
};

export default DeleteWarning;